import React, { useState, useContext } from "react";
import "./PreferencesSidebar.css";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useMediaQuery from "@mui/material/useMediaQuery";
import { AccountContext } from "@/context/AccountContext";

export default function Sidebar(props) {
  const { t } = useTranslation();
  const context = useContext(AccountContext);
  const [mobileShowSettingsList, setMobileShowSettingsList] = useState(true);
  const isMobile = useMediaQuery("(max-width:900px)");

  // Build menu items array for alternating background
  const menuItems = [
    { to: "/preferences/tags", label: t("settings.tags"), show: true },
    {
      to: "/preferences/favorites",
      label: t("settings.favorites"),
      show: true,
    },
    { to: "/preferences/users", label: t("settings.user"), show: true },
    {
      to: "/permissions/groups",
      label: t("groups.groups"),
      show:
        context.userData.client_id !== null && context.userData.client_id !== 0,
    },
    {
      to: "/preferences/locations",
      label: t("settings.locations"),
      show:
        context.userData.client_id !== null && context.userData.client_id !== 0,
    },
    { to: "/preferences/general", label: t("settings.general"), show: true },
    { to: "/preferences/profile", label: t("settings.profile"), show: true },
    {
      to: "/preferences/security",
      label: t("settings.twoFactor", { defaultValue: "Zwei-Faktor-Auth." }),
      show: true,
    },
    { to: "/preferences/payment", label: t("settings.payments"), show: true },
    {
      to: "/preferences/mailtemplates",
      label: t("settings.mailTemplates"),
      show: true,
    },
    { to: "/preferences/mailarchive", label: t("settings.mail"), show: true },
    {
      to: "/preferences/referral",
      label: t("settings.referral"),
      // Brands (own domain or tenant link) are not sophyapp, so they get no
      // sophyapp referral code.
      show: !context.isBrandingCustomer,
    },
    { to: "/preferences/logging", label: t("settings.logging"), show: true },
    { to: "/preferences/version", label: t("settings.version"), show: true },
  ];

  // Filter visible items and assign even/odd for alternating background
  const visibleItems = menuItems.filter((item) => item.show);

  const sidebarNav = (
    <div className="prefs-sidebar-nav">
      {visibleItems.map((item, index) => (
        <NavLink key={item.to} to={item.to}>
          <div
            className={`prefs-menu-item ${
              index % 2 === 1 ? "prefs-row-even" : ""
            }`}
            onClick={isMobile ? () => setMobileShowSettingsList(false) : null}
          >
            {item.label}
          </div>
        </NavLink>
      ))}
    </div>
  );

  const mainContent = (
    <div className="prefs-main-content">
      {isMobile && (
        <div
          className="prefs-mobile-backlink"
          onClick={() => setMobileShowSettingsList(true)}
        >
          <span className="prefs-back-arrow">←</span>
          {t("settings.backlink")}
        </div>
      )}
      <div className="prefs-content-header">{props.title}</div>
      <div>{props.contentdisplay}</div>
    </div>
  );

  // Desktop layout - simple flexbox
  const desktopContent = (
    <div className="prefs-sidebar-container h-100">
      {sidebarNav}
      <div className="prefs-gap"></div>
      {mainContent}
    </div>
  );

  // Mobile layout - show either sidebar or content
  const mobileContent = mobileShowSettingsList ? (
    <div className="prefs-sidebar-nav prefs-sidebar-nav-mobile">
      {visibleItems.map((item, index) => (
        <NavLink key={item.to} to={item.to}>
          <div
            className={`prefs-menu-item ${
              index % 2 === 1 ? "prefs-row-even" : ""
            }`}
            onClick={() => setMobileShowSettingsList(false)}
          >
            {item.label}
          </div>
        </NavLink>
      ))}
    </div>
  ) : (
    <div className="prefs-main-content prefs-main-content-mobile">
      <div
        className="prefs-mobile-backlink"
        onClick={() => setMobileShowSettingsList(true)}
      >
        <span className="prefs-back-arrow">←</span>
        {t("settings.backlink")}
      </div>
      <div className="prefs-content-header">{props.title}</div>
      <div>{props.contentdisplay}</div>
    </div>
  );

  return (
    <div className="h-100">{isMobile ? mobileContent : desktopContent}</div>
  );
}
